import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./css/Cart.module.css";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { Link } from "react-router-dom";

// Define types for the cart item
interface CartItem {
  name: string;
  price: number;
  quantity: number;
}

const Cart: React.FC = () => {
  const [cartItems, setCartItems] = useState<CartItem[]>([]);

  const language = useSelector((state: any) => state.language.value);
  const dispatch = useDispatch();

  const reduxState = useSelector((state: any) => state);
  useEffect(() => {
    const storedItems = JSON.parse(localStorage.getItem("cartItems") || "[]");
    setCartItems(storedItems);
  }, []);

  const updateQuantity = (index: number, newQuantity: number): void => {
    const updatedItems = [...cartItems];
    updatedItems[index].quantity = Math.max(1, newQuantity);
    setCartItems(updatedItems);
    localStorage.setItem("cartItems", JSON.stringify(updatedItems));
  };

  const removeItem = (index: number): void => {
    const userConfirmed = window.confirm(
      "Are you sure you want to remove this item?"
    );
    if (userConfirmed) {
      const updatedItems = cartItems.filter((_, i) => i !== index);
      setCartItems(updatedItems);
      localStorage.setItem("cartItems", JSON.stringify(updatedItems));
    }
  };

  // Calculate the estimated total dynamically
  const estimatedTotal = cartItems.reduce(
    (total, item) => total + item.price * item.quantity,
    0
  );

  useEffect(() => {
    console.log(language);
  }, [language]);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.productContainer}>
        <div className={styles.frame}>
          <span className={styles.productTitle}>
            {language === "EN" && "Your cart"}
            {language === "RO" && "Coșul tău"}
            {language === "RU" && "Ваша корзина"}
          </span>
          <div className={styles.productTitle1}>
            <Link to="/">
              <span className={styles.continueShopping}>
                {language === "EN" && "Continue shopping"}
                {language === "RO" && "Continuă cumpărăturile"}
                {language === "RU" && "Продолжить покупки"}
              </span>
            </Link>
          </div>
        </div>
        <div className={styles.orderItems}>
          <div className={styles.itemContainer}>
            <div className={styles.itemHeader}>
              <div className={styles.productLabel}>
                <span className={styles.product}>
                  {language === "EN" && "Product"}
                  {language === "RO" && "Produs"}
                  {language === "RU" && "Продукт"}
                </span>
              </div>
              <div className={styles.frame2}>
                <div className={styles.variantLabel}>
                  <span className={styles.quantity}>
                    {language === "EN" && "Quantity"}
                    {language === "RO" && "Cantitate"}
                    {language === "RU" && "Количество"}
                  </span>
                </div>
                <div className={styles.totalAmountLabel}>
                  <span className={styles.total}>
                    {language === "EN" && "Total"}
                    {language === "RO" && "Total"}
                    {language === "RU" && "Итого"}
                  </span>
                </div>
              </div>
            </div>
            <div className={styles.divider} />
            {cartItems.map((item, index) => (
              <div className={styles.itemDetails} key={index}>
                <div className={styles.frame3}>
                  <div className={styles.rectangle} />
                  <div className={styles.frame4}>
                    <span className={styles.productName}>{item.name}</span>
                    <span className={styles.productName5}>
                      {item.price} lei
                    </span>
                  </div>
                </div>
                <div className={styles.frame6}>
                  <div className={styles.frame7}>
                    <button className={styles.button}>
                      <div
                        className={styles.increaseQuantityContainer}
                        onClick={() => updateQuantity(index, item.quantity - 1)}
                      >
                        <span className={styles.decreaseQuantity}>-</span>
                      </div>

                      <span className={styles.quantity8}>{item.quantity}</span>
                      <div
                        className={styles.increaseQuantityContainer}
                        onClick={() => updateQuantity(index, item.quantity + 1)}
                      >
                        <span className={styles.increaseQuantity}>+</span>
                      </div>
                    </button>
                    <DeleteOutlineOutlinedIcon
                      style={{ color: "#C4B57C", cursor: "pointer" }}
                      onClick={() => removeItem(index)}
                    />
                  </div>
                  <span className={styles.productTotal}>
                    {(item.price * item.quantity).toFixed(2)} lei
                  </span>
                </div>
              </div>
            ))}
            <div className={styles.divider9} />
          </div>
          <div className={styles.summary}>
            <div className={styles.frameA}>
              <div className={styles.summaryRow}>
                <span className={styles.totalAmountLabelB}>
                  {language === "EN" && "Estimated total"}
                  {language === "RO" && "Total estimat"}
                  {language === "RU" && "Предварительный итог"}
                </span>
                <span className={styles.totalAmountCost}>
                  {estimatedTotal.toFixed(2)} lei
                </span>
              </div>
              <div className={styles.frameC}>
                <div className={styles.summaryRowD}>
                  <span className={styles.shippingLabel}>
                    {language === "EN" &&
                      "Shipping and discounts calculated at checkout."}
                    {language === "RO" &&
                      "Livrarea și reducerile sunt calculate la finalizarea comenzii."}
                    {language === "RU" &&
                      "Доставка и скидки рассчитываются при оформлении заказа."}
                  </span>
                </div>
                <span className={styles.taxInfo}>
                  {language === "EN" && "Tax included"}
                  {language === "RO" && "Taxa inclusă"}
                  {language === "RU" && "Налог включен"}
                </span>
              </div>
            </div>
            {cartItems.length > 0 ? (
              <Link to="/checkout" className={styles.buttonE}>
                <span className={styles.checkOut}>
                  {language === "EN" && "Check out"}
                  {language === "RO" && "Plasează comanda"}
                  {language === "RU" && "Оформить заказ"}
                </span>
              </Link>
            ) : (
              <div className={`${styles.buttonE} ${styles.disabled}`}>
                <span className={styles.checkOut}>
                  {language === "EN" && "Check out"}
                  {language === "RO" && "Plasează comanda"}
                  {language === "RU" && "Оформить заказ"}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cart;
